//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const GroupPermissions: FeatureFlag = {"Id":"GroupPermissions","Label":"Show permission assignment for groups","Impact":"Allow assign permissions directly to groups to allow more granular access controls than allowed by roles","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
